import { ReactElement, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    Box,
    Dialog,
    DialogActions,
    Grid,
    IconButton,
    Typography,
} from '@mui/material';
import {
    AppFormikButtonTiles,
    AppFormikTextField,
    AppPrimaryButton,
} from 'shared/components/AppComponents';
import CloseIcon from '@mui/icons-material/Close';
import { Formik } from 'formik';
import { ManageAccessService } from 'services';
import { ManageAccessNewMemberScheme } from 'validators/ManageAccessScheme';
import { Utils } from 'shared/helpers';
import { typeMap } from './components/data/typeMap';

const ManageAccessEditDialog = (props: ManageAccessEditProps): ReactElement => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { showForm, onCloseForm, onFinishForm, acccessState } = props;

    const [rolesData, setRolesData] = useState<roleData[] | null>(null);

    const [rolesOption, setRoleOption] = useState<roleOption[]>([]);

    useEffect(() => {
        ManageAccessService.getRoles().then((roles) => {
            const rolesArray: roleData[] = roles.data.data[0].paginatedResult;
            const rolesOptionArray: roleOption[] = [];
            rolesArray.forEach((el) => {
                const role = typeMap[el.role];
                rolesOptionArray.push({ value: role[0] });
            });
            setRoleOption(rolesOptionArray);
            setRolesData(rolesArray);
        });
    }, []);
    // UI Elements
    const actionAccessOnSubmit = useCallback(
        (value: any) => {
            const rolesIndex = value.roles.findIndex(
                (el: boolean) => el === true
            );
            const roleData = rolesData?.at(rolesIndex);

            ManageAccessService.sendInvitationMember({
                email: value.email,
                roleId: roleData?.roleId ?? '',
                firstName: value.firstname,
                middleName: value.middlename,
                lastName: value.lastname,
            })
                .then((response) => {
                    Utils.handleSuccessResponse(response);
                    onFinishForm();
                })
                .catch(Utils.handleErrorResponse);
        },
        [onFinishForm, rolesData]
    );

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={showForm}
            className="edit-wrapper"
        >
            <Box className="header">
                <Typography variant="h3">New</Typography>
                <IconButton
                    edge="end"
                    onClick={onCloseForm}
                    className="app-icon-close"
                    title="close"
                >
                    <CloseIcon className="close-icon" />
                </IconButton>
            </Box>
            <Formik
                enableReinitialize
                validationSchema={ManageAccessNewMemberScheme}
                initialValues={{
                    roles: [],
                    email: '',
                    firstname: '',
                    lastname: '',
                    middlename: '',
                }}
                validateOnMount
                onSubmit={actionAccessOnSubmit}
            >
                {({ handleSubmit }) => (
                    <>
                        <Grid className="content" container spacing={1}>
                            <Grid item xs={12} md={5}>
                                <AppFormikTextField
                                    name="email"
                                    placeholder="Type here"
                                    className="email-access-input"
                                    outerLabel
                                    label="Email"
                                />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={rolesOption.length > 4 ? 12 : 7}
                            >
                                <AppFormikButtonTiles
                                    variant="outlined"
                                    size="small"
                                    name="roles"
                                    multichoice={false}
                                    className="button-tiles-roles"
                                    label="Select the role"
                                    buttons={rolesOption}
                                    outerLabel
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <AppFormikTextField
                                    name="firstname"
                                    placeholder="Type here"
                                    className="email-access-input"
                                    outerLabel
                                    label="Firstname"
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <AppFormikTextField
                                    name="middlename"
                                    placeholder="Type here"
                                    className="email-access-input"
                                    outerLabel
                                    label="Middlename"
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <AppFormikTextField
                                    name="lastname"
                                    placeholder="Type here"
                                    className="email-access-input"
                                    outerLabel
                                    label="Lastname"
                                />
                            </Grid>
                        </Grid>

                        <DialogActions className="px-6">
                            <AppPrimaryButton
                                className="btn-small mb-4 update-access"
                                title="Invite"
                                onClick={handleSubmit}
                                loadingSize={22}
                                loadingText="PROCESSING"
                            />
                        </DialogActions>
                    </>
                )}
            </Formik>
        </Dialog>
    );
};

const mapStateToProps = (state: any): any => ({
    profileState: state.profileState,
});

const mapDispatchToProps = (): any => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ManageAccessEditDialog);
